import { CallIntelligenceService } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2';
import { MockPersons } from '@frontend/api-person';
import { DemoIdUtils, DemoInterceptorUtils, FeatureMockRouter } from '@frontend/demo-interceptors';
import { serviceName } from '../../service';
import * as CallIntelTypes from '../../types';
import { BaseMockRouterContext } from './types';

export interface CallIntelRecordsMockRouterContext extends BaseMockRouterContext {
  mockPersonsInstance: MockPersons;
}

export const CallIntelRecordsMockRouter: FeatureMockRouter<CallIntelRecordsMockRouterContext> = {
  getRequestInterceptors: ({ interceptorIdPrefix, mockPersonsInstance, vertical, hasVoiceAiAccess }) => [
    {
      id: `${interceptorIdPrefix}-call-records`,
      interceptor: async (request: Request) => {
        const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
          schemaMethod: CallIntelligenceService.ListCalls,
          requestUrl: request.url,
          method: request.method,
        });

        if (!isMatching) {
          return request;
        }

        const requestBody: CallIntelTypes.ListCallsIO['input'] = await request.clone().json();
        requestBody.isDemo = true;
        requestBody.demoMetadata = {
          ...requestBody.demoMetadata,
          vertical,
          features: {
            enableCallIntelligence: true,
            enableVoiceAi: hasVoiceAiAccess,
          },
        };

        const { personId: personIdList } =
          requestBody.filter?.[CallIntelTypes.FilterTypeEnum.FILTER_BY_PERSON_ID] ?? {};
        const personId = personIdList?.[0] ?? '';

        if (!DemoIdUtils.checkIsDemoId(personId)) {
          return new Request(request, {
            body: JSON.stringify(requestBody),
          });
        }

        const personData = mockPersonsInstance.getFilteredPersons({ personId })?.[0];
        const personFilter = requestBody.filter?.[CallIntelTypes.FilterTypeEnum.FILTER_BY_PERSON_ID];

        if (personData && personFilter && personIdList) {
          personFilter.personId = personIdList.map(DemoIdUtils.removeDemoDataFromId);

          return new Request(request, {
            body: JSON.stringify({
              ...requestBody,
              isCallTrendDemo: true,
              isDemo: true,
              demoMetadata: {
                ...requestBody.demoMetadata,
                vertical,
                firstName: personData.firstName,
                lastName: personData.lastName,
                gender: personData.gender,
                features: {
                  enableCallIntelligence: true,
                  enableVoiceAi: hasVoiceAiAccess,
                },
                enableDemoCallPool: true,
              },
            } as CallIntelTypes.ListCallsIO['input']),
          });
        }

        return new Request(request, {
          body: JSON.stringify(requestBody),
        });
      },
    },
  ],
  invalidateQueries: (queryClient) => {
    queryClient.invalidateQueries([serviceName, 'ListCalls']);
  },
};
